import { render } from "./XIconSolidCoins.vue?vue&type=template&id=01f77418"
import script from "./XIconSolidCoins.vue?vue&type=script&lang=js"
export * from "./XIconSolidCoins.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidCoins.vue"]])

export default __exports__